// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1839":"68e60fda1e73b2a2","4056":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};